import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltipDummy: {
        id: 'custom.products.IM.tooltip.Dummy',
        defaultMessage: 'Dummy'
    }
    
})